import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
`

export const FooterWrapper = styled.footer`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${theme.spacing.sm};
`

export const InputWrapper = styled.div`
  width: 100%;
`
